import AnnotatedMetricResultSchema, {
  AnnotatedMetricResult
} from '../schemas/AnnotatedMetricResultSchema'

export default function MetricResultVo(initData: unknown = {}): AnnotatedMetricResult {
  return AnnotatedMetricResultSchema.validateSync(initData)
}
